import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NumberInput, Tooltip } from "../../revvComponents";

const PriceMatrixRow = ({
  currencySymbol,
  data,
  deleteLastEntry,
  index,
  onChange,
  readOnly,
  totalEntries,
}) => {
  const { min, max, value } = data;
  let inputClassname = "pricing-options-input";
  if (totalEntries !== index && totalEntries !== 0) {
    inputClassname += "disabled-input form-control";
  }
  return (
    <div className="range-container row">
      <div className="col-md-8 range">
        <div className="col-md-6">
          <input
            className="pricing-options-input readonly-input form-control"
            type="text"
            value={min}
            disabled
            readOnly
          />
          <span className="range-to">-</span>
        </div>
        <div className="col-md-6">
          <NumberInput
            className={inputClassname}
            value={max}
            placeholder="& above"
            onChange={maxValue => {
              onChange(index, "max", maxValue, min);
            }}
            disabled={
              readOnly || (totalEntries !== index && totalEntries !== 0)
            }
            data-test="pricematrixrow-max-min-input"
          />
        </div>
      </div>
      <div className="col-md-4">
        <NumberInput
          className={inputClassname}
          disabled={readOnly}
          inpCurrencySymbol={currencySymbol}
          isCurrency
          isFloat
          placeholder="Enter Value"
          value={value}
          onChange={price => {
            onChange(index, "value", price);
          }}
          data-test="pricematrixrow-price-input"
        />
      </div>
      <div className="remove-pricerange">
        {totalEntries === index && totalEntries !== 0 && !readOnly ? (
          <span
            onKeyPress={deleteLastEntry}
            role="button"
            tabIndex="0"
            onClick={deleteLastEntry}>
            <Tooltip placement="top" overlay="Remove Range">
              <FontAwesomeIcon icon={["far", "times-circle"]} />
            </Tooltip>
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default PriceMatrixRow;
